import React, { useContext, useRef } from 'react'
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css'
import { GVarState } from '../StoreState/Gstate';

function ShowSelectPoint() {
    let g = useContext(GVarState);
    let setwrap = useRef()
    return (
        <>
            {g.EndSearchInput &&
                g.EndSearchInput.point &&
                <>
                    <div className='ShowStore'>
                        <div className='showDir p-4'>
                            <div className='flex items-center'>
                                <span className='w-16 rounded-lg border' ><img className='rounded-lg p-1' src={g.EndSearchInput.point?.logo.url} alt="" /></span>
                                <span className='px-2 w-full font-bold '><p>{g.EndSearchInput.point?.LocationName.text}</p></span>
                            </div>
                            {g.EndSearchInput?.point && g.EndSearchInput.point.extra?.TotleImg &&
                                <Slide cssClass="slider_class">
                                    {g.EndSearchInput.point.extra?.TotleImg.map((d, i) => {
                                        console.log("d", d[i])
                                        return <div key={i}>
                                            <img src={d[i]} />
                                        </div>
                                    })}
                                </Slide>
                            }
                            <div className='p-2 gFayxe' ref={setwrap} onClick={() => {
              setwrap.current.classList.toggle("gFayxe");
              setwrap.current.classList.toggle("dAFXpl");
            }}  >
                                <p>{g.EndSearchInput.point?.Description}</p>
                            </div>
                        </div>
                    </div>
                    <div className='fixed bottom-2 w-full text-center'>
                        <button className='dirBtn' onClick={() => {
                            g.setStartAndEndPart(true)
                        }} >Get Directions</button>

                    </div>
                </>
            }
        </>
    )
}

export default ShowSelectPoint